<script generic="TModelValue extends string | number" lang="ts" setup>
import { ref, watch } from 'vue';
import { type LabelValuePair } from '../types';
import CheckboxField from './CheckboxField.vue';

interface Props {
  path: string;
  options: LabelValuePair<TModelValue>[];
  readonly?: boolean;
  disabled?: boolean;
  hasError?: boolean;
  enableSelectAll?: boolean;
  showAsColumn?: boolean;
}

const props = defineProps<Props>();

const model = defineModel<TModelValue[]>({ default: [] });

const selectAll = ref(false);

const allOptionsSelected = () => props.options.every((e) => model!.value!.includes(e.value));

watch(
  model,
  () => {
    selectAll.value = allOptionsSelected();
  },
  { immediate: true },
);

watch(selectAll, (doSelectAll) => {
  if (doSelectAll) {
    model.value = [
      ...model.value,
      ...props.options
        .filter((option) => !model.value.includes(option.value))
        .map((option) => option.value),
    ];
  } else if (allOptionsSelected()) {
    model.value = model.value.filter(
      (value) => !props.options.find((option) => option.value === value),
    );
  }
});
</script>

<template>
  <div
    :class="[
      'flex gap-2',
      {
        'flex-wrap': !props.showAsColumn,
        'flex-col': props.showAsColumn,
      },
    ]"
  >
    <CheckboxField
      v-if="props.enableSelectAll && !readonly"
      v-model="selectAll"
      :path="`${props.path}-selectall`"
      sub-label="Alles selecteren"
      :disabled="props.disabled"
      :readonly="props.readonly"
      :has-error="props.hasError"
    />

    <CheckboxField
      v-for="option in props.options"
      v-model="model"
      :value="option.value"
      :key="`${props.options.indexOf(option)}-${option.value}`"
      :path="`${props.path}-${option.value}`"
      :sub-label="option.label"
      :disabled="props.disabled"
      :readonly="props.readonly"
      :has-error="props.hasError"
      style-as-field
    />
  </div>
</template>
